import { DownloadRounded } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import axios from "axios";
import {
	agreementData,
	companyBasicDetailColumns,
	companyRegistredAddressDetailColumns,
	industryTypeValues,
	supplierAgreementTypes,
} from "data/supplierPageData";
import FileSaver from "file-saver";
import { useState, useEffect } from "react";
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { GlobalState } from "../../../../context/GlobalContext";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { grey } from "@mui/material/colors";
import StatusButtons from "components/SupplierPage/reusableComp/statusButton";
import moment from "moment";
import { getSupplierFileSignedUrl } from "../CompanyDetails/data";
import { getLatestApproval } from "utils/supplierApprovalHelpers";
import { SupplierPageHeader, SupplierSection, supplierUi } from "../../shared/supplierUi";

const Agreements = ({ companyData, disableEdit, hidePageHeader = false, handleReject, updateSupplierStore, handleUnapprove, setCompanyData }) => {
	let [emptyColms, setEmptyColms] = useState([]);
	let [loading, setLoading] = useState(true);
	const [open, setOpen] = React.useState(false);
	const [file, setFile] = useState(null);
	const [uploadedFileData, setUploadedFileData] = useState([]);
	const [selectedFileType, setSelectedFileType] = useState();
	const { snackBar, snackBarOpen, setSnackBarOpen, setLoadingOpen, loginUser, setSnackBar } = GlobalState();

	const largeScaleCompanyAgreementUrl = "";
	const agreementDownloadFunctions = {
		[supplierAgreementTypes.vendor_agreement.key]: async () => {
			let apiBody = {};
			let arr = [];
			setLoading(true);
			setLoadingOpen(true);
			Object.keys(agreementData).forEach((col) => (apiBody[col] = companyData[col]));
			Object.keys(companyRegistredAddressDetailColumns).forEach((col) => {
				apiBody[col] = companyData[col];
				if (companyData[col] == "" || companyData[col] === 0) arr.push(companyRegistredAddressDetailColumns[col].name);
			});

			if (arr.length === 0) {
				try {
					let columns = {
						registred_office_address: "registred_office_address",
						registred_office_state: "registred_office_state",
						registred_office_city: "registred_office_city",
						registred_office_pin_code: "registred_office_pin_code",
						company_name: "company_name",
					};
					let body = Object.keys(columns).reduce((acc, row) => {
						return { ...acc, [row]: companyData[row] };
					}, {});
					body["date"] = moment().format("YYYY-MM-DD");
					setEmptyColms([]);

					await axios.post(`/api/supplier/genearte_agreement`, body, { responseType: "blob" }).then((res) => {
						FileSaver(res.data, "vendorAgreement");
						setLoadingOpen(false);
					});
				} catch (error) {
					console.log(error);
					setLoadingOpen(false);
				}
				setLoading(false);
			} else {
				setEmptyColms(arr);
				setLoading(false);
				setLoadingOpen(false);
			}
		},
		[supplierAgreementTypes.decleration_agreemnt.key]: () => {
			window.location.href =
				"https://storage.googleapis.com/rarebox_public/SupplierAgreementUploadFormats/SupplierAgreementUploadFormats_DECLARATION_OF_MSME_STATUS.pdf";
		},
	};
	useEffect(() => {
		setUploadedFileData(companyData.supplierAgreement);
	}, [companyData]);

	const handleClickOpen = (file_type) => {
		setOpen(true);
		setSelectedFileType(file_type);
	};

	const handleClose = () => {
		setOpen(false);
		setFile(null);
	};

	const handleDownloadClick = async () => {
		let apiBody = {};
		let arr = [];
		setLoading(true);
		setLoadingOpen(true);
		Object.keys(agreementData).forEach((col) => (apiBody[col] = companyData[col]));
		Object.keys(companyRegistredAddressDetailColumns).forEach((col) => {
			apiBody[col] = companyData[col];
			if (companyData[col] == "" || companyData[col] === 0) arr.push(companyRegistredAddressDetailColumns[col].name);
		});

		if (arr.length === 0) {
			try {
				let columns = {
					registred_office_address: "registred_office_address",
					registred_office_state: "registred_office_state",
					registred_office_city: "registred_office_city",
					registred_office_pin_code: "registred_office_pin_code",
					company_name: "company_name",
				};
				let body = Object.keys(columns).reduce((acc, row) => {
					return { ...acc, [row]: companyData[row] };
				}, {});
				body["date"] = moment().format("YYYY-MM-DD");
				setEmptyColms([]);

				await axios.post(`/api/supplier/genearte_agreement`, body, { responseType: "blob" }).then((res) => {
					FileSaver(res.data, "vendorAgreement");
					setLoadingOpen(false);
				});
			} catch (error) {
				console.log(error);
				setLoadingOpen(false);
			}
			setLoading(false);
		} else {
			setEmptyColms(arr);
			setLoading(false);
			setLoadingOpen(false);
		}
	};
	const handleLargeScaleCompanyAgreementDownloadClick = async () => {
		window.location.href = largeScaleCompanyAgreementUrl;
	};

	async function generatePuclicUrl(fileName, download) {
		// const url = `https://storage.googleapis.com/rarebox_files/Supplier_Agreement_Files/${fileName}`;
		const url = await getSupplierFileSignedUrl(`/rarebox_files/Supplier_Agreement_Files/${fileName}`);
		if (download) window.open(url, "_blank");
		// return url;
	}

	const handleAgreementUploadToDB = async (newFileName, url) => {
		let body = {};
		const isAgreementPresent = uploadedFileData?.filter((row) => row.type === selectedFileType);
		if (isAgreementPresent?.length > 0) {
			body = {
				...isAgreementPresent[0],
				name: newFileName,
				url,
			};
		} else {
			body = {
				name: newFileName,
				type: selectedFileType,
				url,
				supplier_id: loginUser.id,
			};
		}
		setLoadingOpen(true);
		try {
			await axios.post("/api/supplier/agreement_to_sql", body).then((res) => {
				const newAllFiles = body?.id
					? uploadedFileData?.map((row) => {
							if (row.id === body.id) return body;
							else return row;
					  })
					: [...uploadedFileData, res.data];
				setUploadedFileData(newAllFiles);
				setCompanyData({ ...companyData, supplierAgreement: newAllFiles });

				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: "Successfully uploaded file", severity: "success" });
			});
		} catch (err) {
			console.log("err", err);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: "Unable to upload file ", severity: "error" });
		}
		setLoadingOpen(false);
		setFile(null);
		setSelectedFileType("");
	};

	// handle resume upload htmlFor join us form
	const handleFileUpload = async () => {
		let form = new FormData();
		form.append("files", file);
		form.append("mobile_no", loginUser.mobile_no);
		form.append("name", loginUser.name);
		setLoadingOpen(true);
		handleClose();
		try {
			await axios
				.post("/api/supplier/upload_supplier_agreement", form, {
					headers: { "Content-Type": "multipart/form-data" },
				})
				.then((res) => {
					handleAgreementUploadToDB(res.data[0].name, res.data[0].publicUrl);
				});
		} catch (err) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: "Unable to upload file in bucket", severity: "error" });
			setLoadingOpen(false);
		}
	};

	const handleFileChange = (e) => {
		const newFile = e.target.files[0];
		setFile(newFile);
	};

	const handleRejectedFactoryButton = (type) => {
		if (typeof handleReject === "function") handleReject(type);
	};

	const logeduser = loginUser.role?.FINANCE_VIEWER ? true : false;
	const vendorApproval = getLatestApproval(companyData?.supplierApproval, "vendor_agreement");
	const approved = vendorApproval?.approved;
	return (
		<Stack width="100%" spacing={2.5}>
			{!hidePageHeader ? (
				<SupplierPageHeader
					title="Agreements"
					subtitle="Download templates and upload signed vendor agreements"
					actions={
						<StatusButtons
							handleReject={() => handleRejectedFactoryButton("vendor_agreement")}
							handleApproval={() => updateSupplierStore("vendor_agreement")}
							handleUnapprove={() => handleUnapprove && handleUnapprove("vendor_agreement")}
							disableEdit={disableEdit}
							handleEdit={() => {}}
							editButton={false}
							otherAccess={!logeduser}
							buttonName="Edit"
							approved={approved}
							remark={vendorApproval?.remark}
							action={vendorApproval?.action}
						/>
					}
				/>
			) : (
				<Stack direction="row" justifyContent="flex-end">
					<StatusButtons
						handleReject={() => handleRejectedFactoryButton("vendor_agreement")}
						handleApproval={() => updateSupplierStore("vendor_agreement")}
						handleUnapprove={() => handleUnapprove && handleUnapprove("vendor_agreement")}
						disableEdit={disableEdit}
						handleEdit={() => {}}
						editButton={false}
						otherAccess={!logeduser}
						buttonName="Edit"
						approved={approved}
						remark={vendorApproval?.remark}
						action={vendorApproval?.action}
					/>
				</Stack>
			)}

			{/* vendor Agreement */}

			{companyData &&
				uploadedFileData &&
				Object.keys(supplierAgreementTypes)?.map((file_key) => {
					let agreementDataRow = supplierAgreementTypes[file_key];

					let arr = uploadedFileData?.filter((fileData) => fileData.type === file_key);
					const fileData = arr?.length ? arr[0] : null;
					console.log("fileData", fileData, uploadedFileData);
					return (
						<Stack
							key={file_key}
							border={`1px solid ${supplierUi.border}`}
							sx={{ margin: 0, bgcolor: "#fff", boxShadow: supplierUi.shadow }}
							borderRadius={supplierUi.radius}
							p={2}
							spacing={3}
							display={
								typeof agreementDataRow.display === "function" &&
								agreementDataRow.display(companyData ? companyData[companyBasicDetailColumns.industry_type.key] : "")
									? "block"
									: !agreementDataRow.display
									? "block"
									: "none"
							}>
							<Typography variant="subtitle1" fontWeight={600} width="100%">
								{agreementDataRow.name}
							</Typography>
							{!disableEdit && (
								<Stack spacing={1}>
									<Box flexWrap={"wrap"} display="flex" width="100%" columnGap={5} rowGap={1} alignItems="center">
										<Typography width="maxContent">Download {agreementDataRow.name}</Typography>
										<Button
											disabled={
												approved //||
												// companyData[companyBasicDetailColumns.industry_type.key] ===
												// 	industryTypeValues.large_scale
											}
											startIcon={<DownloadRounded />}
											variant="contained"
											sx={{ width: 150 }}
											onClick={
												agreementDownloadFunctions && agreementDownloadFunctions[file_key]
													? () => {
															agreementDownloadFunctions[file_key]();
													  }
													: () => {}
											}>
											{"Download"}
										</Button>
										{/* <Button
								disabled={true}
								startIcon={<DownloadRounded />}
								variant="contained"
								sx={{ width: 180 }}
								onClick={handleDownloadClick}>
								{"Download"}
							</Button> */}
										<Stack>
											{emptyColms.length > 0 && (
												<Typography variant="body1" fontSize={16} width="100%" color="error">
													fill these details to download :{emptyColms?.map((row) => `${row} `)}
												</Typography>
											)}
										</Stack>
									</Box>
								</Stack>
							)}
							{!disableEdit && (
								<Stack spacing={1}>
									<Box display="flex" width="100%" columnGap={5} alignItems="center">
										Please upload the signed agreement file.
										<Button variant="outlined" disabled={approved} onClick={() => handleClickOpen(file_key)}>
											Upload file
										</Button>
									</Box>
								</Stack>
							)}
							{fileData ? (
								<Box>
									<TableContainer sx={{ width: "650px" }} component={Paper}>
										<Table sx={{ minWidth: 650 }} aria-label="simple table">
											<TableHead>
												<TableRow>
													<TableCell>File Name</TableCell>
													<TableCell>Last Update</TableCell>
													<TableCell align="right">Download</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow
													key={fileData?.name}
													sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
													<TableCell component="th" scope="row">
														{fileData?.name}
													</TableCell>
													<TableCell component="th" scope="row">
														{moment(fileData?.updatedAt).format("DD-MM-YYYY")}
													</TableCell>
													<TableCell align="right">
														<IconButton
															sx={{ cursor: "pointer" }}
															onClick={() => generatePuclicUrl(fileData?.name, true)}>
															<DownloadRounded />
														</IconButton>
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</TableContainer>
								</Box>
							) : (
								disableEdit && (
									<Typography
										variant="h6"
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										color={"red"}
										width="100%">
										Signed agreement is not uploaded
									</Typography>
								)
							)}
						</Stack>
					);
				})}

			<React.Fragment>
				<Dialog
					// sx={{ width: "300px" }}
					maxWidth="sm"
					open={open}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title">
					<DialogTitle id="responsive-dialog-title">{"Upload File"}</DialogTitle>
					<DialogContent>
						<input type="file" required id="file" onChange={handleFileChange} />
					</DialogContent>
					<DialogActions>
						<Button variant="outlined" autoFocus onClick={handleClose}>
							Cancel
						</Button>
						<Button disabled={file === null} variant="contained" onClick={handleFileUpload} autoFocus>
							Upload
						</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		</Stack>
	);
};

export default Agreements;
